<template>
  <div class="card-img-top rounded-top">
    <transition name="fade" duration="250" mode="out-in">
      <div
        :key="'placeholder'"
        v-if="!playerJsInitialized">
        <img
          slot="image"
          @click.prevent="initPlayerJs(playerId)"
          class="poster-image card-img-bottom"
          style="cursor: pointer;"
          :src="poster"
          :alt="poster"/>
      </div>
      <div
        :key="'player'"
        v-else
        v-bind:id="this.playerId">
      </div>
    </transition>
  </div>
</template>

<script>
  import {PlayerjsMixin} from "../../mixins/Video/Playerjs";

  export default {
    name: "PlayerjsPlayer",
    props: {
      id: String,
      width: String,
      height: String,
      outputUrl: String,
      poster: String,
      fullWidth: {
        type: Boolean,
        default: true
      }
    },
    mixins: [
      PlayerjsMixin
    ],
    mounted() {
      this.handlePlayerJs(this.playerId)
    },
    watch: {
      'outputUrl': 'initPlayer'
    },
    computed: {
      playerOptions() {
        return {
          id: this.playerId,
          file: this.outputUrl,
        }
      },
      playerId() {
        return `PlayerJS-${this.id}`
      }
    },
    beforeDestroy() {
      this.destroyPlayer()
    },

  }
</script>

<style lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .poster-image {
    cursor: zoom-in;
  }
</style>
